export default "__VITE_ASSET__B9y2Yuz3__"